import { render, staticRenderFns } from "./NoticeForm.vue?vue&type=template&id=2dbe76df&scoped=true"
import script from "./NoticeForm.vue?vue&type=script&lang=js"
export * from "./NoticeForm.vue?vue&type=script&lang=js"
import style0 from "./NoticeForm.vue?vue&type=style&index=0&id=2dbe76df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe76df",
  null
  
)

export default component.exports